import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
  } from "@mui/material";
  
  const ConfirmationDialog = ({ open, onClose, onConfirm, title, description }) => {
    return (
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="xs" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            backgroundColor: "white",
            border: "1px solid #e2e8f0",
          }
        }}
      >
        <DialogTitle sx={{ 
          fontWeight: 600, 
          color: "#1e293b",
          pb: 1
        }}>
          {title}
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Typography sx={{ color: "#64748b" }}>
            {description}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button 
            onClick={onClose}
            sx={{
              color: "#64748b",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#f1f5f9",
              },
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={onConfirm}
            sx={{
              backgroundColor: "#0f172a",
              color: "white",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "#1e293b",
              },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ConfirmationDialog;
  